<template>
  <v-dialog
    :value="errors.length > 0"
    width="480"
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        <template>エラーが発生しました</template>
      </v-card-title>

      <v-card-text>
        <ul class="errors">
          <li
            v-for="(msg, index) in errors"
            :key="index"
          >
            <template>{{ msg }}</template>
          </li>
        </ul>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="back"
        >
          <template>戻る</template>
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="reload"
        >
          <template>再読み込み</template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
@import '@/libs/vuetify/styles/variables.scss';

.errors {
  margin-top: 1rem;
  padding-left: 0;
  list-style: none;
  color: $title-black-text-color;

  > li:empty::after {
    content: '\3000'
  }
}
</style>

<script>
export default {
  name: 'AppError',
  props: {
    errors: {
      type: Array,
      required: true
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    reload () {
      location.reload(false)
    }
  }
}
</script>
